(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iconic-branding-text"] && !Shopify.designMode) return;
  try {
    
  function adjustFontSizeToFill(containerId, textId) {
    const container = document.getElementById(containerId);
    const text = document.getElementById(textId);
    if (!text) return;
  
    function adjustFontSize() {
      const targetPercentage = window.innerWidth <= 767
      ? parseFloat(text.getAttribute('data-font-size-mobile')) || 100
      : parseFloat(text.getAttribute('data-font-size')) || 100;
      
      let fontSize = 10;
      let increment = 1;
      let maxWidth = container.offsetWidth * (targetPercentage / 100);
      text.style.whiteSpace = 'nowrap';
      text.style.fontSize = `${fontSize}px`;
  
      while (text.offsetWidth < maxWidth && fontSize < 300) {
        fontSize += increment;
        text.style.fontSize = `${fontSize}px`;
      }
  
      if (text.offsetWidth > maxWidth) {
        fontSize -= increment;
        text.style.fontSize = `${fontSize}px`;
      }
      text.classList.add('adjusted');
    }
  
    setTimeout(() => {
      adjustFontSize();
    }, 250);
  
    window.addEventListener('resize', adjustFontSize);
  }
  
  function applyFontAdjustments() {
    const brandingSections = document.querySelectorAll('.iconic-branding-text-section');
    
    brandingSections.forEach((section) => {
      const sectionId = section.getAttribute('data-section-id');
      const containerId = `brandingWrapper-${sectionId}`;
      const textId = `brandingText-${sectionId}`;
      adjustFontSizeToFill(containerId, textId);
    });
  }
  window.addEventListener('load', applyFontAdjustments);
  document.addEventListener('DOMContentLoaded', applyFontAdjustments);
  
  document.addEventListener('shopify:section:load', function () {
    applyFontAdjustments();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
